import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
import { useQuery } from "react-query";
import { Center, Spinner } from "@chakra-ui/react";
import API from "../shared-utils/api";
const CustomerContext = createContext(undefined);
export const useCustomer = () => {
    const context = useContext(CustomerContext);
    if (context === undefined) {
        throw new Error("useCustomer must be used within a CustomerProvider");
    }
    return context;
};
// Optional hook that returns null if not within CustomerProvider
export const useCustomerOptional = () => {
    const context = useContext(CustomerContext);
    return context || null;
};
export const CustomerProvider = ({ children, }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(() => localStorage.getItem("is_phone_verified") === "true");
    const { data: customerData, error, isLoading, refetch, } = useQuery(["customerProfile"], async () => {
        if (!isLoggedIn)
            return null;
        const { data } = await API.get("/api/v1/rbzo/user/profile");
        return data.data;
    }, {
        enabled: isLoggedIn,
        retry: false,
        staleTime: 5 * 60 * 1000,
        cacheTime: 30 * 60 * 1000,
    });
    const login = () => {
        localStorage.setItem("is_phone_verified", "true");
        setIsLoggedIn(true);
    };
    const logout = () => {
        localStorage.clear();
        window.location.href = "/home";
    };
    if (isLoading && isLoggedIn) {
        return (_jsx(Center, { w: "100vw", h: "100vh", background: "#111111", children: _jsx(Spinner, { color: "white" }) }));
    }
    return (_jsx(CustomerContext.Provider, { value: {
            customerData,
            isLoading,
            error,
            logout,
            refetchProfile: refetch,
            login,
        }, children: children }));
};
